import { __extends } from "tslib";
import { ProductDirectiveBaseController } from '../common/models/product-directive-base.controller';
import { fetchAttributes } from './utilities/fetch-attributes';
var ProductAttributesDirectiveController = /** @class */ (function (_super) {
    __extends(ProductAttributesDirectiveController, _super);
    function ProductAttributesDirectiveController($scope, $transclude, $element, $q) {
        var _this = _super.call(this, $scope, $transclude, $element) || this;
        _this.$scope = $scope;
        _this.$transclude = $transclude;
        _this.$element = $element;
        _this.$q = $q;
        return _this;
    }
    ProductAttributesDirectiveController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
    };
    ProductAttributesDirectiveController.prototype.updateFromProduct = function (productId) {
        var _this = this;
        this.transclude();
        this.$q.when(fetchAttributes(productId, this.$scope.pType))
            .then(function (attributes) {
            if (attributes === void 0) { attributes = []; }
            _this.$scope.attributes = attributes;
        });
    };
    ProductAttributesDirectiveController.$inject = ['$scope', '$transclude', '$element', '$q'];
    return ProductAttributesDirectiveController;
}(ProductDirectiveBaseController));
export var ProductAttributesDirective = [
    function () {
        return {
            controller: ProductAttributesDirectiveController,
            restrict: 'E',
            scope: {
                pId: '<',
                pType: '@',
            },
            transclude: true,
        };
    },
];
